/* eslint-disable */
import { PublisherThemeConfigProvider, PublisherThemeExtendedChakraProvider } from "theme";
import { BASE_DOMAIN } from "env";
import "../legal-styles.css";

const TOS_URL = `https://widget.${BASE_DOMAIN}/ui/terms-of-service`;
const PRIVACY_URL = `https://widget.${BASE_DOMAIN}/ui/privacy-policy`;
const GLBA_URL = `https://widget.${BASE_DOMAIN}/ui/glba-notice`;

export const GLBANoticeContent = () => {
  return (
    <section className="py-40-m-30 legalese">
      <div className="section-container w-container">
        <div>
          <h1 className="legal-page-h1">U.S. GLBA Notice</h1>
          <p className="legal-paragraph-centered">
            <a href={PRIVACY_URL} target="_blank" className="bold-link">
              <strong>
                Online Privacy Policy
                <br />‍
              </strong>
            </a>
            <strong>Tilia U.S. GLBA Notice</strong>
          </p>
        </div>
        <div className="legal-flex">
          <div className="div-legal-header">
            <h2 className="legal-h2-2">
              Why?
              <br />
            </h2>
          </div>
          <div className="paragraph">
            Financial companies choose how they share your personal information. Federal law gives
            consumers the right to limit some but not all sharing. Federal law also requires us to
            tell you how we collect, share, and protect your personal information. Please read this
            notice carefully to understand what we do with the personal information that you provide
            to us. This GLBA Notice applies to the personal information of U.S. users that we
            collect in connection with the solicitation and provision of our payment and stored
            value services. Other information we collect from U.S. persons will be subject to the
            provisions of the{" "}
            <a href={PRIVACY_URL} target="_blank">
              Online Privacy Policy
            </a>
            .
          </div>
        </div>
        <div className="legal-flex">
          <div className="div-legal-header">
            <h2 className="legal-h2-2">
              What?
              <br />
            </h2>
          </div>
          <div className="paragraph">
            The types of personal information we collect and share depend on the product or service
            you utilize from us. This information can include:
            <br />
            <br />
            A. Name, Social Security number, date of birth, postal address, email address, phone
            number, and any other information that we may use to contact you, verify your identity,
            or manage fraud and other types of risk;
            <br />
            <br />
            B. Payment and transaction information, including financial account information (for
            instance, credit card and/or debit card account information, and payment provider
            account information;
            <br />
            <br />
            C. Credit history and credit information that may be provided by identify verification
            sources to help complete our identification process; and,
            <br />
            <br />
            D. Username, password, secret questions, secret answers, and other types of
            authenticating credentials to help verify your identity and the permissible use of our
            service or product.
          </div>
        </div>
        <div className="legal-flex">
          <div className="div-legal-header">
            <h2 className="legal-h2-2">
              How?
              <br />
            </h2>
          </div>
          <div className="paragraph">
            All financial companies need to share customers’ personal information to run their
            everyday business. In the section below, we list the reasons financial companies can
            share their customers’ personal information; the reasons Tilia chooses to share; and
            whether you can limit this sharing.
          </div>
        </div>
        <div className="legal-flex-table header">
          <div className="paragraph table-50">
            <strong>Reasons we can share your personal information</strong>
            <br />
          </div>
          <div className="paragraph table center">
            <strong>Does Tilia share?</strong>
            <br />
          </div>
          <div className="paragraph table center">
            <strong>Can you limit this sharing?</strong>
            <br />
          </div>
        </div>
        <div className="legal-flex-table row">
          <div className="paragraph table-50">
            <strong>For our everyday business purposes—</strong>
            <br />
            such as to process your transactions, maintain your account(s), respond to court orders
            and legal investigations, or report to credit bureaus
            <br />
          </div>
          <div className="paragraph table cell">
            Yes
            <br />
          </div>
          <div className="paragraph table cell">
            No
            <br />
          </div>
        </div>
        <div className="legal-flex-table row">
          <div className="paragraph table-50">
            <strong>For our marketing purposes—</strong>
            <br />
            to offer our products and services to you
            <br />
          </div>
          <div className="paragraph table cell">
            No
            <br />
          </div>
          <div className="paragraph table cell">
            We do not share information for such purpose
            <br />
          </div>
        </div>
        <div className="legal-flex-table row">
          <div className="paragraph table-50">
            <strong>For joint marketing with other financial companies—</strong>
            <br />
          </div>
          <div className="paragraph table cell">
            No
            <br />
          </div>
          <div className="paragraph table cell">
            We do not share information for such purpose
            <br />
          </div>
        </div>
        <div className="legal-flex-table row">
          <div className="paragraph table-50">
            <strong>For our affiliates &#x27;everyday business purposes—</strong>
            <br />
            information about your transactions and experiences
            <br />
          </div>
          <div className="paragraph table cell">
            Yes
            <br />
          </div>
          <div className="paragraph table cell">
            No
            <br />
          </div>
        </div>
        <div className="legal-flex-table row">
          <div className="paragraph table-50">
            <strong>For our affiliates &#x27;everyday business purposes—</strong>
            <br />
            information about your creditworthiness
            <br />
          </div>
          <div className="paragraph table cell">
            No
            <br />
          </div>
          <div className="paragraph table cell">
            We do not share information for such purpose
            <br />
          </div>
        </div>
        <div className="legal-flex-table row">
          <div className="paragraph table-50">
            <strong>For our affiliates to market to you—</strong>
            <br />
          </div>
          <div className="paragraph table cell">
            No
            <br />
          </div>
          <div className="paragraph table cell">
            We do not share information for such purpose
            <br />
          </div>
        </div>
        <div className="legal-flex-table row">
          <div className="paragraph table-50">
            <strong>For non-affiliates to market to you—</strong>
            <br />
          </div>
          <div className="paragraph table cell">
            No
            <br />
          </div>
          <div className="paragraph table cell">
            We do not share information for such purpose
            <br />
          </div>
        </div>
        <div className="legal-flex">
          <div className="div-legal-header">
            <h3 className="legal-h3-2">
              Questions?
              <br />
            </h3>
          </div>
          <div className="div-block-20">
            <div className="paragraph vert-center">
              Call 1.855.979.1500 or go to <a href="https://tiliapay.freshdesk.com/support/home" target="_blank">tilia.io/support</a>.
            </div>
          </div>
        </div>
        <div className="legal-flex">
          <div className="div-legal-header center">
            <h2 className="legal-h2-2">
              Who we are
              <br />
            </h2>
            <div className="legal-flex _100">
              <div className="div-legal-header single">
                <div className="paragraph">
                  Who is providing this notice?
                  <br />
                </div>
              </div>
              <div className="paragraph">
                Tilia LLC
                <br />
              </div>
            </div>
          </div>
        </div>
        <div className="legal-flex">
          <div className="div-legal-header center">
            <h2 className="legal-h2-2">
              What we do
              <br />
            </h2>
            <div className="legal-flex _100">
              <div className="div-legal-header single">
                <div className="paragraph">
                  <strong>How does Tilia protect my personal information?</strong>
                  <br />
                </div>
              </div>
              <div className="paragraph">
                To protect your personal information from unauthorized access and use, we maintain
                electronic, physical and procedural controls and safeguards, including but not
                limited to security measures that comply with applicable federal and state laws. We
                also require our service providers and business partners to whom we disclose the
                information to take similar measures.
                <br />
                <br />
                Although we have implemented reasonable and appropriate safeguards to protect
                personal information, no security is perfect. We cannot guarantee that
                communications between you and us, or information stored on our websites or servers,
                will be completely free from unauthorized access or use. To the fullest extent
                permitted by law, we disclaim all liability and responsibility for any damages
                (including but not limited to any and all direct, special, indirect, consequential
                or punitive loss or other damages of any kind, whether in contract, tort (including
                negligence) or otherwise, that you may suffer due to any loss, unauthorized access,
                misuse or alteration of any information we collect.
                <br />
              </div>
            </div>
            <div className="legal-flex _100">
              <div className="div-legal-header single">
                <div className="paragraph">
                  <strong>How does Tilia collect my personal information?</strong>
                  <br />
                </div>
              </div>
              <div className="div-block-75-percent">
                <div className="paragraph">
                  We collect your personal information, for example, when you:
                  <br />
                </div>
                <ul role="list" className="paragraph paragraph-list">
                  <li>Request products, services or information from us</li>
                  <li>Register an account with us</li>
                  <li>
                    Participate in public forums or other activities on our sites and applications
                  </li>
                  <li>Respond to customer inquiries or surveys</li>
                  <li>
                    Visit or use our sites and applications or use our applications on third-party
                    sites or platforms, including collection through technology such as cookies
                  </li>
                  <li>Use your credit card, debit card or other payment method</li>
                </ul>
                <div className="paragraph list">
                  We also collect information about you from others, such as individuals and
                  financial institutions, credit bureaus, affiliates or other companies (such as
                  identity verification services and consumer reporting agencies).
                  <br />
                  <br />
                  Please keep in mind that when you provide information to us on a third-party site
                  or platform (for example, through our applications), the information you provide
                  may be separately collected by the third-party site or platform. The information
                  we collect is covered by this GLBA Notice and the information that the third-party
                  site or platform collects is subject to the third-party site or platform’s privacy
                  practices. Privacy choices you have made on the third-party site or platform will
                  not apply to our use of the information we have collected directly through our
                  applications.
                  <br />
                </div>
              </div>
            </div>
            <div className="legal-flex _100">
              <div className="div-legal-header single">
                <div className="paragraph">
                  <strong>Why can’t I limit all sharing?</strong>
                  <br />
                </div>
              </div>
              <div className="div-block-75-percent">
                <div className="paragraph">
                  Federal law gives you the right to limit only:
                  <br />
                </div>
                <ul role="list" className="paragraph paragraph-list">
                  <li>
                    sharing for affiliates’ everyday business purposes—information about your
                    creditworthiness
                    <br />
                  </li>
                  <li>
                    affiliates from using your information to market to you
                    <br />
                  </li>
                  <li>
                    sharing for non-affiliates to market to you
                    <br />
                  </li>
                </ul>
                <div className="paragraph list">
                  State laws and individual companies may give you additional rights to limit
                  sharing. See below for more on your rights under state law.
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="legal-flex">
          <div className="div-legal-header center">
            <h2 className="legal-h2-2">
              Definitions
              <br />
            </h2>
            <div className="legal-flex _100">
              <div className="div-legal-header single">
                <div className="paragraph">
                  <strong>Affiliates</strong>
                  <br />
                </div>
              </div>
              <div className="div-block-75-percent">
                <div className="paragraph">
                  Companies related by common ownership or control. They can be financial and
                  nonfinancial companies.
                  <br />
                </div>
                <ul role="list" className="paragraph paragraph-list">
                  <li>
                    Linden Research, Inc. (d/b/a Linden Lab)
                    <br />
                  </li>
                  <li>
                    Tilia Branch UK Ltd.
                    <br />
                  </li>
                </ul>
              </div>
            </div>
            <div className="legal-flex _100">
              <div className="div-legal-header single">
                <div className="paragraph">
                  <strong>Non-affiliates</strong>
                  <br />
                </div>
              </div>
              <div className="div-block-75-percent">
                <div className="paragraph">
                  Companies not related by common ownership or control. These entities can be
                  financial and nonfinancial companies.
                  <br />
                </div>
              </div>
            </div>
            <div className="legal-flex _100">
              <div className="div-legal-header single">
                <div className="paragraph">
                  <strong>Joint marketing</strong>
                  <br />
                </div>
              </div>
              <div className="div-block-75-percent">
                <div className="paragraph">
                  A formal agreement between non-affiliated financial companies that together market
                  financial products or services to you.
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="legal-flex">
          <div className="div-legal-header center">
            <h2 className="legal-h2-2">
              Other important information
              <br />
            </h2>
          </div>
        </div>
        <div className="legal-flex _100 vertical">
          <div className="div-legal-header single">
            <div className="paragraph _100">
              <strong>STATE PRIVACY LAWS</strong>
              <br />
            </div>
          </div>
          <div className="div-block-75-percent _100">
            <div className="paragraph _100">
              We will comply with applicable state privacy laws.
              <br />
            </div>
            <ul role="list" className="paragraph paragraph-list _100">
              <li>
                California Residents: We will not share your information with companies outside of
                Tilia and our affiliates, except for our everyday business purposes, for marketing
                our products and services to you, or with your consent.
                <br />
              </li>
              <li>
                Vermont Residents: We will not share your information with companies outside of
                Tilia and our affiliates, except for our everyday business purposes, for marketing
                our products and services to you, or with your consent. We will not disclose credit
                information about you within or outside Tilia except as required or permitted by
                law.
                <br />
              </li>
              <li>
                Nevada Residents: Notice provided pursuant to state law. To be placed on our
                internal Do Not Call List, call 1-855-979-1500. If you would like more information
                about telemarketing practices, you may contact us at Tilia LLC, 8605 Santa Monica
                Blvd PMB 59201, West Hollywood, California 90069-4109 US or at 1-855-979-1500. For
                more on this Nevada law, contact Bureau of Consumer Protection, Office of the Nevada
                Attorney General, 555 E. Washington St., Suite 3900, Las Vegas, NV 89101; Phone
                number: 1-702-486-3132; E-mail:{" "}
                <a href="mailto:BCPINFO@ag.state.nv.us?subject=BCPINFO%20Query%20from%20tilia.io">
                  BCPINFO@ag.state.nv.us.
                </a>
                <br />
              </li>
            </ul>
          </div>
        </div>
        <div className="legal-flex _100 vertical">
          <div className="div-legal-header single">
            <div className="paragraph _100">
              <strong>DATA RETENTION</strong>
              <br />
            </div>
          </div>
          <div className="div-block-75-percent _100">
            <div className="paragraph _100">
              Tilia retains your personal information for as long as it is deemed necessary and
              relevant by Tilia for Tilia’s operations unless a longer or different retention period
              is required or permitted by law.
              <br />
            </div>
            <ul role="list" className="paragraph paragraph-list _100"></ul>
          </div>
        </div>
        <div className="legal-flex _100 vertical">
          <div className="div-legal-header single _100">
            <div className="paragraph _100">
              <strong>UPDATING, CORRECTING AND DELETING YOUR PERSONAL INFORMATION</strong>
              <br />
            </div>
          </div>
          <div className="div-block-75-percent _100">
            <div className="paragraph _100">
              If your personal information changes or if you believe it is inaccurate, you may
              verify, correct or update it by contacting our Privacy Officer through any of the
              means identified above. If you wish to remove your personal information from the Site,
              please contact our Privacy Officer in writing using the contact information found
              above with directions authorizing the removal of your personal information.
              <br />
            </div>
            <ul role="list" className="paragraph paragraph-list _100"></ul>
          </div>
        </div>
        <div className="legal-flex _100 vertical">
          <div className="div-legal-header single _100">
            <div className="paragraph _100">
              <strong>OTHER INFORMATION</strong>
              <br />
            </div>
          </div>
          <div className="div-block-75-percent _100">
            <div className="paragraph _100">
              See our online{" "}
              <a href={PRIVACY_URL} target="_blank">
                Privacy Policy
              </a>&nbsp;
              to learn more about information collected through our website and how we use and
              disclose it. That Privacy Policy should be regarded as part of this GLBA Notice.
              <br />
            </div>
            <ul role="list" className="paragraph paragraph-list _100"></ul>
          </div>
        </div>
        <div className="legal-flex _100 vertical">
          <div className="div-legal-header single _100">
            <div className="paragraph _100">
              <strong>BUSINESS TRANSITIONS &amp;ASSIGNMENT</strong>
              <br />
            </div>
          </div>
          <div className="div-block-75-percent _100">
            <div className="paragraph _100">
              Your personal information may be shared with or assigned to third parties in
              connection with Tilia undergoing a corporate reorganization, or negotiating or
              undergoing a merger, amalgamation with another entity or a sale of its assets,
              provided that the personal information so disclosed continues to be used for the
              purposes permitted by this GLBA Notice by the entity acquiring the personal
              information. Also, if any bankruptcy or reorganization proceeding is brought by or
              against Tilia, such personal information may be considered an asset of Tilia and may
              be sold or transferred to third parties.
              <br />
            </div>
            <ul role="list" className="paragraph paragraph-list _100"></ul>
          </div>
        </div>
      </div>
    </section>
  );
};

const GLBANotice = () => {
  return (
    <PublisherThemeConfigProvider>
      <PublisherThemeExtendedChakraProvider>
        <GLBANoticeContent />
      </PublisherThemeExtendedChakraProvider>
    </PublisherThemeConfigProvider>
  );
};

export default GLBANotice;
